export class FancyboxLoader {
    initialize() {
        const fancyboxElements = document.querySelectorAll('[data-fancybox]');

        if (fancyboxElements.length > 0) {
            import('@fancyapps/fancybox')
        }
    }
}
